'use strict';
var novicell = novicell || {};
var nvcl = nvcl || {};

// 'novicell.signoutRedirect.init();

// Document ready
document.addEventListener('DOMContentLoaded', function () {
  svg4everybody(); // Fix SVG spritemap in IE/Edge
  // novicell.signinRedirect.init();
  novicell.checkboxes.init();
  novicell.gobackRedirect.init();
  novicell.formValidation.init();
  novicell.faq.init();
  novicell.login.init();

  novicell.emailValidation.init();
});
